/*
 * @Author: your name
 * @Date: 2021-09-02 21:48:40
 * @LastEditTime: 2021-09-02 22:39:29
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \lwdgis-ui\src\V3\js\eventBus.js
 */
import mitt from 'mitt'
const eventBus = mitt()
export default eventBus


// WEBPACK FOOTER //
// ./src/V3/js/eventBus.js